/**
 * @description
 * Deeply merges two objects and returns the result.
 *
 * Used as a drop-in replacement for lodash's merge function, in order to reduce
 * bundle size.
 *
 * @param {Object} obj1 - The first object to merge
 * @param {Object} obj2 - The second object to merge
 * @returns {Object} - The merged object
 **/
export default function deepMerge(obj1, obj2) {
  const output = Object.assign({}, obj1);
  for (const key in obj2) {
    if (
      isObject(obj2[key]) &&
      Object.prototype.hasOwnProperty.call(obj1, key) &&
      isObject(obj1[key])
    ) {
      output[key] = deepMerge(obj1[key], obj2[key]);
    } else {
      output[key] = obj2[key];
    }
  }
  return output;
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}
